import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_LONG_MINUTE_FNS, DATE_FORMAT_ISO_FNS } from 'CorePackage/MainModule/constants/dateFormats';

import { RenderFunc } from '../types/RenderFunc';

export const renderDateWithTime: RenderFunc = item => {
  const { newValue, oldValue } = item;
  const stringOldValue = typeof oldValue === 'string' ? oldValue : '';
  const stringNewValue = typeof newValue === 'string' ? newValue : '';

  return {
    renderedOldValue: formatDate({
      date: stringOldValue,
      dateFormat: DATE_FORMAT_LONG_MINUTE_FNS,
      parseFormat: DATE_FORMAT_ISO_FNS,
    }),
    renderedNewValue: formatDate({
      date: stringNewValue,
      dateFormat: DATE_FORMAT_LONG_MINUTE_FNS,
      parseFormat: DATE_FORMAT_ISO_FNS,
    }),
  };
};
